/** Mirrors backend CATEGORY_FOLDER_NAMES for default category folder paths. */
const CATEGORY_FOLDER: Record<string, string> = {
    invoice: 'Invoices',
    vendor_invoice: 'Invoices',
    invoices: 'Invoices',
    vendor_invoices: 'Invoices',
    bill: 'Bills',
    vendor_bill: 'Bills',
    bills: 'Bills',
    vendor_bills: 'Bills',
    expense: 'Expenses',
    expenses: 'Expenses',
    other: 'Other',
};

const ROOT = 'Documents';

function sanitizeWorkspaceSegment(value?: string | null): string {
    const text = (value || '').trim();
    if (!text) return 'Unknown';
    return text.replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim() || 'Unknown';
}

export function buildWorkspaceFolderPath(categoryKey: string, entityLabel?: string | null): string {
    const folder = CATEGORY_FOLDER[categoryKey] ?? CATEGORY_FOLDER.other;
    return `${ROOT}/${folder}/${sanitizeWorkspaceSegment(entityLabel)}`;
}

/** Top-level category path only (parent for "New folder" under a category). */
export function categoryRootFolderPath(categoryKey: string): string {
    const folder = CATEGORY_FOLDER[categoryKey] ?? CATEGORY_FOLDER.other;
    return `${ROOT}/${folder}`;
}

/** Default entity folder when dropping onto a category row (matches backend Unknown segment). */
export function defaultFolderPathForCategory(categoryKey: string): string {
    return buildWorkspaceFolderPath(categoryKey, 'Unknown');
}

export function categoryLabelForKey(categoryKey: string): string {
    return CATEGORY_FOLDER[categoryKey] ?? CATEGORY_FOLDER.other;
}

/** Virtual folder for Google Sheets imports (matches backend GOOGLE_SHEETS_WORKSPACE_FOLDER_PATH). */
export function googleSheetsWorkspaceFolderPath(): string {
    return buildWorkspaceFolderPath('other', 'Google Sheets');
}

/**
 * Sheets imported before backend set `workspace_folder_path` may show as Documents/Other/Unknown.
 * Display the intended Finz Docs path unless the user moved the file elsewhere.
 */
export function displayWorkspaceFolderPathForFile(file: {
    source_channel?: string | null;
    workspace_folder_path?: string | null;
}): string | undefined {
    const p = (file.workspace_folder_path || '').trim();
    const isSheet = (file.source_channel || '').trim() === 'google_sheets';
    if (!isSheet) {
        return p || undefined;
    }
    const intended = googleSheetsWorkspaceFolderPath();
    if (!p) {
        return intended;
    }
    const unknownDefault = defaultFolderPathForCategory('other');
    if (p === unknownDefault || p.endsWith('/Other/Unknown')) {
        return intended;
    }
    return p;
}
